import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import { RtOverlayConfig } from './overlay-state';

export const getNextUniqueId = (() => {
  let nextId = 0;
  return () => nextId++;
})();

@Injectable({ providedIn: 'root' })
export class RtOverlay extends Overlay {
  public create(config?: RtOverlayConfig): OverlayRef {
    const overlayRef = super.create(config);
    const { level = this.getContainerLevel() } = config || {};
    const { overlayElement, hostElement, backdropElement } = overlayRef;

    hostElement.id = `rt-overlay-${getNextUniqueId()}`;
    hostElement.style.zIndex = `${9000 + level}`;

    let backdrop = backdropElement;
    Object.defineProperty(overlayRef, '_backdropElement', {
      get(): any {
        return backdrop;
      },
      set(value: HTMLElement) {
        backdrop = value;
        if (backdrop) {
          backdrop.style.zIndex = `${9000 + level}`;
        }
        return backdrop;
      },
    });

    overlayElement.classList.add('rt-overlay-pane');
    return overlayRef;
  }

  private getContainerLevel() {
    console.warn('Container level not provided!');
    return 0;
  }
}
